import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import { useNavigate } from "react-router-dom";
//styled
export default function ClassBookingConfirmed({ notification }) {
  const [isLoading, setIsLoading] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [club, setClub] = useState(null);
  const [event, setEvent] = useState(null);
  const formattedDate = new Date(notification.bookingDate).toLocaleDateString();
  const navi = useNavigate();
  const { user } = useAuthContext();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const bookingsResponse = await axios.get(
        `${ApiConnectionString}/api/BookingsByEvent/${notification.eventId}/${notification.bookingDate}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setProfiles(bookingsResponse.data);
      setClub(bookingsResponse.data[0].viewClubs);
      setEvent(bookingsResponse.data[0].viewEvent);
      // Process the response as needed
    } catch (error) {
      // Handle the error (e.g., log it or display an error message)
      console.error("Error fetching bookings:", error);
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div className="container">
        <LoadingSpinner />
      </div>
    );
  } else {
    if (club) {
      return (
        <div className="container text-center bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Booking Confirmation(s)</p>
          </div>
          <div className="row">
            <div className="col">
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Club</p>
              </div>
              <p
                onClick={() => navi(`/myoneclub/${club.id}`)}
                className="fw-bold red-text pointer"
              >
                {club.name}
              </p>
              <div
                onClick={() => navi(`/myoneclub/${club.id}`)}
                className="circle-crop mx-auto"
              >
                <img
                  src={
                    club.image
                      ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                      : NoImagePlaceholder
                  }
                  alt="Club Image"
                  className="mt-0 pointer"
                />{" "}
              </div>
            </div>
            <div className="col">
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Class</p>
              </div>
              <div className="not-static-timetable-wkday">
                <p>{formattedDate}</p>
                <p>{event.day}</p>
              </div>
              <div className="not-static-class-content text-center">
                <p class="fontSize20">{event.name}</p>
                <p class="fontSize12">{event.description}</p>
                <p class="fontSize14">Time in {event.timeIn}</p>
                <p class="fontSize14">Time out {event.timeOut}</p>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div className="lightBlueBanner mt-3 ">
                <p className="fw-bold p-2">Current users booked in</p>
              </div>

              <div className="d-flex justify-content-center">
                {profiles.map((addProfile) => (
                  <div
                    className="bg-white d-flex profileBox rounded shadow mt-3"
                    key={addProfile.id}
                  >
                    <div>
                      <img
                        src={
                          addProfile.viewBookingProfile.image
                            ? `${ApiConnectionString}/api/profileImage/${addProfile.viewBookingProfile.id}`
                            : ProfilePlaceHolder
                        }
                        alt="Profile Image"
                        width={200}
                        className=" m-3 circle-crop"
                      />
                    </div>

                    <div className="mx-5 mt-5">
                      <p className="red-text">Username</p>
                      <p className="fw-bold mt-2">
                        {addProfile.viewBookingProfile.username}
                      </p>
                    </div>
                    <div className="mx-5 mt-5">
                      <p className="red-text">Name</p>
                      <p className="fw-bold">
                        {addProfile.viewBookingProfile.firstName +
                          " " +
                          addProfile.viewBookingProfile.lastName}
                      </p>
                    </div>

                    <div className="ms-auto align-self-start">
                      {/* <Dropdown>
                      <Dropdown.Toggle
                        as="span"
                        id="dropdown-custom-components"
                        className="dropdown-toggle-custom"
                      >
                        <ThreeDotsVertical
                          style={{ cursor: "pointer" }}
                          onClick={() => setSelectedProfile(addProfile)}
                          size={25}
                          className="m-2"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => setAdditionalEditProfile(true)}
                        >
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => setDeleteProfileModal(true)}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
